import api from 'Application/api/api';

const createIntroduction = (projectId, data, cancelToken = null) =>
    api.post(`project-manager/projects/${projectId}/introductions`, data, {
        cancelToken,
    });

export default createIntroduction;
